module.exports = __webpack_public_path__ + "static/Personalisation-24e82350e44ac1a3cafa7a2fa1fbb52f.png";